import script from "./ScrollToTopButtonLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollToTopButtonLite.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollToTopButtonLite.vue?vue&type=style&index=0&id=c5266384&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5266384"]])

export default __exports__